import { Config } from '@model/config';

/**
 * The entry of the Packages interface. The build is always Packages (`VITE_PRODUCT=packages`): it never calls
 * the Workspace administration, and it ships without the Workspace client and its editor.
 */
const config = new Config();
void import('./packages').then(module => new module.PackagesClient(config).start());
